export const NEW_ANALYSIS_ACCOUNT_VALUE = '__new_account__';
export const ANALYSIS_ACCOUNT_MODE_PARAM = 'account';
export const ANALYSIS_ACCOUNT_MODE_NEW = 'new';

export function isNewAnalysisAccountMode(searchParams: URLSearchParams): boolean {
  return searchParams.get(ANALYSIS_ACCOUNT_MODE_PARAM) === ANALYSIS_ACCOUNT_MODE_NEW;
}

/** @deprecated Prefer account ids from the manual-accounts API (`manual:{uuid}`). */
export function manualReportAnalysisProfileId(userId: string | undefined | null): string {
  const id = userId?.trim();
  return id ? `manual:${id}` : '';
}

export function isManualReportAnalysisProfileId(profileId: string): boolean {
  return profileId.trim().toLowerCase().startsWith('manual:');
}

export function filterAnalysisAccounts<T>(
  accounts: T[],
  query: string,
  label: (row: T) => string
): T[] {
  const needle = query.trim().toLowerCase();
  if (!needle) return accounts;
  return accounts.filter((row) => label(row).toLowerCase().includes(needle));
}
